import * as React from 'react';
import { Button } from "reactstrap";

interface IProps {
  value: any;
  placeholder?: string;
  onClick?: any;
  id: string;
  type?: any;
  className?: string;
}

interface IState { }

class DABButton extends React.Component<IProps, IState>  {
  constructor(props: any) {
    super(props);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick(event) {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }

  render() {
    return (
      <Button type={this.props.type}
        onClick={(event) => this.handleOnClick(event)}
        className={"btn-submit-frm " + this.props.className}>
        {this.props.value}
      </Button>)
  }
}

export default DABButton;